import { getClass } from "../../Helper"

export const createUserObject = (user, keysOnly) => {
  let class_list = getClass();
  let userObject = {
    ge: [],
    exam: [],
    manage: [],
    online: [],
    tt: [],
    academic: [],
    // tech: [String], // not used yet
    lms: [],
    vet: [],
    ld: [],

    bsb: [],
    chc: [],
    cpp: [],
    cua: [],
    fns: [],
    fsk: [],
    hlt: [],
    ict: [],
    shb: [],
    sis: [],
    sit: [],
    tae: [],
    vet_other: [],
  }

  const getValues = (key, whole_name = key) => {
    if (keysOnly) {
      return key;
    }
    else {
      return { key, whole_name }
    }
  }

  // check for the new version first
  if (user.can_delivers) {
    for (let category in user.can_delivers) {
      if (category !== "_id") {
        user.can_delivers[category].forEach(entry => {
          let class_type = class_list.find(cl => cl.key === entry)
          if (class_type && userObject[category]) {
            let item = getValues(entry, class_type.whole_name)
            userObject[category].push(item)
          }
        })
      }
    }
  }

  // otherwise use the old version
  else {
    // console.log(user.can_deliver)
    user.can_deliver.forEach((c) => {
      let class_type = {};

      if (
        c.can_deliver === "All ELICOS" ||
        c.can_deliver === "Beginner/Starter" ||
        c.can_deliver === "Elementary GE" ||
        c.can_deliver === "Pre-Intermediate GE" ||
        c.can_deliver === "Intermediate GE" ||
        c.can_deliver === "Upper-Intermediate GE" ||
        c.can_deliver === "Blended Lower GE" ||
        c.can_deliver === "Blended Upper GE" ||
        c.can_deliver === "Advanced GE" ||
        c.can_deliver === "Young Learners" ||
        c.can_deliver === "Teens" ||
        c.can_deliver === "Business English" ||
        c.can_deliver === "Study Tours" ||
        c.can_deliver === "EAP/Bridging"
      ) {
        // console.log(c.can_deliver)
        class_type = class_list.find(cl => cl.key === c.can_deliver)
        // console.log(class_type)
        if (class_type) {
          userObject.ge.push(getValues(c.can_deliver, class_type.whole_name))
        }
      } else if (
        c.can_deliver === "Cambridge CPE" ||
        c.can_deliver === "Cambridge KEY" ||
        c.can_deliver === "Cambridge PET" ||
        c.can_deliver === "Cambridge FCE" ||
        c.can_deliver === "Cambridge CAE" ||
        c.can_deliver === "PTE" ||
        c.can_deliver === "IELTS" ||
        c.can_deliver === "IELTS Intermediate" ||
        c.can_deliver === "IELTS Advanced" ||
        c.can_deliver === "Occupational English Test"
      ) {
        class_type = class_list.find(cl => cl.key == c.can_deliver)
        if (class_type) {
          userObject.exam.push(getValues(c.can_deliver, class_type.whole_name))
        }
        // } else if (
        //   c.can_deliver === "Business English" ||
        //   c.can_deliver === "Study Tours" ||
        //   c.can_deliver === "EAP/Bridging"
        // ) {
        //   class_type = class_list.find(cl => cl.key == c.can_deliver)
        //   if (class_type) {
        //     userObject.other.push(getValues(c.can_deliver, class_type.whole_name))
        //   }
      } else if (
        c.can_deliver === "Assistant Academic Manager" ||
        c.can_deliver === "Academic Manager" ||
        c.can_deliver === "Student Support Officer" ||
        c.can_deliver === "Social Program Officer"
      ) {
        class_type = class_list.find(cl => cl.key == c.can_deliver)
        if (class_type) {
          userObject.manage.push(getValues(c.can_deliver, class_type.whole_name))
        }
      } else if (
        c.can_deliver === "Zoom" ||
        c.can_deliver === "Skype" ||
        c.can_deliver === "Bb Collaborate Ultra" ||
        c.can_deliver === "Padlet" ||
        c.can_deliver === "Microsoft Teams"
      ) {
        class_type = class_list.find(cl => cl.key == c.can_deliver)
        if (class_type) {
          userObject.online.push(getValues(c.can_deliver, class_type.whole_name))
        }
      } else if (
        c.can_deliver === "Moodle" ||
        c.can_deliver === "Canvas LMS"
      ) {
        class_type = class_list.find(cl => cl.key == c.can_deliver)
        if (class_type) {
          userObject.lms.push(getValues(c.can_deliver, class_type.whole_name))
        }
      }
    })
  }

  // console.log(userObject)
  return userObject
}
